import { EditResponsibleOutDto, EditResponsibleInDto } from '../../../types/responsible.dto'

export const EDIT_RESPONSIBLE = 'EDIT_RESPONSIBLE'
export const EDIT_RESPONSIBLE_SUCCESS = 'EDIT_RESPONSIBLE_SUCCESS'
export const EDIT_RESPONSIBLE_ERROR = 'EDIT_RESPONSIBLE_ERROR'
export const RESET_EDIT_RESPONSIBLE = 'RESET_EDIT_RESPONSIBLE'

export interface EditResponsible {
  type: typeof EDIT_RESPONSIBLE
  payload: EditResponsibleOutDto
}

export interface EditResponsibleSuccess {
  type: typeof EDIT_RESPONSIBLE_SUCCESS
  payload: EditResponsibleInDto
}

export interface EditResponsibleError {
  type: typeof EDIT_RESPONSIBLE_ERROR
  payload: string | boolean
}

export interface ResetEditResponsible {
  type: typeof RESET_EDIT_RESPONSIBLE
  payload: null
}
export interface State {
  data: EditResponsibleInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditResponsible | EditResponsibleSuccess | EditResponsibleError | ResetEditResponsible
